// Confirmed catalog identity is reusable. Each quote's commercial values remain its own.
export function applyReviewDefaults(values, suggestions) {
    const applied = [];
    const lines = values.lines.map((line, index) => {
        const suggestion = suggestions.lines?.find(s => s.index === index);
        const match = suggestion?.autoFill && suggestion.matches?.length === 1 && suggestion.matches[0];
        if (line.product || !match || match.unit !== line.unit || suggestion.description !== line.description || suggestion.supplierSku !== (line.supplierSku || '')) return line;
        const filled = { ...line, product: match.product, itemKey: match.itemKey, factorToBase: match.factorToBase };
        applied.push({ original: line, filled, reason: match.reason });
        return filled;
    });
    return { values: { ...values, lines }, applied };
}

export function restoreReviewDefaults(values, applied) {
    return { ...values, lines: values.lines.map(line => {
        const previous = applied.find(({ filled }) => ['description','supplierSku','unit','product','itemKey','factorToBase'].every(key => line[key] === filled[key]));
        if (!previous) return line;
        // Keep edits to quantities, prices and other quote fields made after the prefill.
        return { ...line, product: previous.original.product || null, itemKey: previous.original.itemKey, factorToBase: previous.original.factorToBase };
    }) };
}

export const supplierSelectionReason = reason => ({
    exact_sender: 'Proveedor cargado por coincidencia exacta con un correo registrado.',
    reviewed_thread: 'Proveedor cargado desde una revisión confirmada de esta conversación.',
    saved_supplier: 'Proveedor registrado en esta cotización.',
    selected_by_reviewer: 'Proveedor seleccionado por usted.'
}[reason] || '');

export function includeSuggestedProducts(products, suggestions) {
    const result = [...products];
    for (const line of suggestions.lines || []) for (const match of line.matches || []) {
        if (!result.some(p => p._id === match.product)) result.push({_id: match.product, code: match.itemKey, name: match.productName || match.itemKey});
    }
    return result;
}
